import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { LSE_EVENTS } from '@/constants';
import { useSearchParams } from '@/hooks';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
export default function SealActivityPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(LSE_EVENTS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [filters]);

  const [data, error] = useApi({
    url: `/lse/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={'MKR'}
                address={'0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2'}
                size="4"
              />
            }>
            <Heading size="1">Seal Activity</Heading>
          </EntityName>
        }>
        <HistoricTabs />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>

        <EventsTable
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
